module.exports = __webpack_public_path__ + "img/bartender.2e6c7bcf.jpg";